import React from 'react';

function TodosError() {
  return <p>¡Hubo un error! Intenta nuevamente</p>;
}

export { TodosError };
